const KPI_NAME = {
  RETURN: "Returns",
  SPH: "SPH",
  BPH: "BPH",
  MAN_POWER: "Man Power",
  MAN_HOURS: "Man Hours",
  OT: "OT",
  PLAN: "Plan",
  REMAIN: "Remain",
  COMP: "Comp",
  PERF: "Perf %",
  MAX_CAP: "Max Cap",
  HRS_PERF: "Hrs Perf %",
  APT: "APT",
};

const KPI_GROUP_LABEL = {
  Deliveries: 1,
  Pickups: 1,
  SPHBPH: 0,
  Priority: 0,
  Manpower: 0,
};

export { KPI_NAME, KPI_GROUP_LABEL};
